import { Link } from "react-router-dom";
import { BUSINESS } from "@/data/site";

export default function CTASection() {
  return (
    <section className="bg-gold">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
        <div>
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-ink/70">
            Free estimates within 100 miles
          </p>
          <h2 className="font-display text-3xl sm:text-5xl font-bold uppercase tracking-tight text-ink mt-2">
            Need mobile welding or fabrication?
          </h2>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <Link
            to="/contact"
            data-testid="final-cta-estimate-button"
            className="inline-flex items-center justify-center bg-ink px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-white hover:bg-steel transition-colors"
          >
            Request a Free Estimate
          </Link>
          <a
            href={BUSINESS.phoneHref}
            data-testid="final-cta-call-button"
            className="inline-flex items-center justify-center border-2 border-ink px-6 py-3 text-sm font-bold uppercase tracking-wider text-ink hover:bg-ink hover:text-gold transition-colors"
          >
            Call {BUSINESS.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
